'use client';
import Link from 'next/link';
import { useState } from 'react';
import type { Article } from '@/lib/articles';
import ArticleCard from '@/components/articles/ArticleCard';
import SectionHeader from '@/components/ui/SectionHeader';

const ITEMS_PER_PAGE = 4;

const LatestArticles = ({ articles }: { articles: Article[] }) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const totalPages = Math.max(1, Math.ceil(articles.length / ITEMS_PER_PAGE));
  const current = articles.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE,
  );

  // Zenn / note から記事が取れなかったビルドでは、セクションごと出さない
  if (articles.length === 0) return null;

  return (
    <section className="section-padding">
      <div className="container-narrow">
        <SectionHeader
          eyebrow="Latest"
          title="新着記事"
          action={
            <Link href="/blog" className="hidden sm:inline-flex btn-tertiary">
              すべての記事を見る
              <span aria-hidden>→</span>
            </Link>
          }
        />

        <>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5">
            {current.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>

          <div className="flex items-center justify-center gap-3 mt-10">
            <button
              onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
              disabled={currentPage === 1}
              className="btn-secondary disabled:opacity-30 disabled:cursor-not-allowed"
            >
              « Prev
            </button>
            <span className="text-ink-subtle font-mono text-caption px-2">
              {currentPage} / {totalPages}
            </span>
            <button
              onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
              disabled={currentPage === totalPages}
              className="btn-secondary disabled:opacity-30 disabled:cursor-not-allowed"
            >
              Next »
            </button>
          </div>

          <div className="text-center mt-6 sm:hidden">
            <Link href="/blog" className="btn-tertiary">
              すべての記事を見る →
            </Link>
          </div>
        </>
      </div>
    </section>
  );
};

export default LatestArticles;
